import { combineReducers } from "redux";
import langReducer from "./lang.reducer";
import userReducer from "./user.reducer";
import bookingReducer from "./booking.reducer";



export default combineReducers({
  langReducer,
  userReducer,
  bookingReducer
});
